<div class="container">
    <div class="header">
        <div class="top-heading">
            <div class="logo text-align-center"></div>
            <br />
            <h1 class="side-title" id="brand-heading">
                Merlin.net&trade; Patient Care Network
            </h1>
        </div>
        <hr class="divider" />
    </div>
    <div id="wrapper">
        <div class="content-wrapper">
            <div class="" [innerHTML]="translate('msg.cs835.text')"></div>
            <div class="button">
                <button
                    id="continue"
                    type="submit"
                    aria-disabled="false"
                    aria-label="Continue"
                    (click)="doLogout()"
                    [innerHTML]="translate('label.gb.ok')"
                ></button>
            </div>
        </div>
    </div>
    <merlin-footer class="termsFooter" [footerData]="footerData" [copyRights]="footerCopyRights"
            [footerClass]="fooMenuClass" [copyrightClass]=""></merlin-footer>
</div>
